




export default { name: 'MyProfile' };
